<script setup lang="ts">
import { Participant } from '@collector/sportsapi-client-legacy'

import ParticipantLogo from './ParticipantLogo.vue'
import ParticipantName from './ParticipantName.vue'

interface Props {
  participant: Participant
  reversed?: boolean
  withTeamColors?: boolean
}
defineProps<Props>()
</script>

<template>
  <div
    class="flex h-8 items-center gap-x-2"
    :class="{
      'flex-row-reverse': reversed,
    }"
  >
    <!-- TODO: tailwind4: text-sm only on narrow container (otherwise, 16px) -->
    <ParticipantName
      class="line-clamp-3 text-sm font-bold"
      :class="{
        'text-right': !reversed,
      }"
      :participant
      :withTeamColors
    />

    <ParticipantLogo :participant />
  </div>
</template>
